/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/widget_ios_medium'
export default icon
